module.exports = __webpack_public_path__ + "img/modules/ui-header/img/a.0dd4fc1467637b6e5a740c7bab1e51da.png";